import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ModalFileInterface } from '../../models/components-general/modal-view-file.model';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { GeneralService } from '../../services/general.service';

@Component({
  selector: 'app-modal-view-file',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, PdfViewerModule],
  templateUrl: './modal-view-file.component.html',
  styleUrl: './modal-view-file.component.scss',
})
export class ModalViewFileComponent {
  public pdfUrl = '';
  public pdfSrc: string | null = null;
  public imagePreview: string | ArrayBuffer | null = null;
  public isDoc = false;

  constructor(
    public dialogRef: MatDialogRef<ModalViewFileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalFileInterface,
    private generalService: GeneralService,
  ) {
    this.onFileSelected(data.file);
  }

  public closeModal(): void {
    this.dialogRef.close(null);
  }

  private isValidBase64(base64: string): boolean {
    try {
      return btoa(atob(base64)) === base64;
    } catch (e) {
      return false;
    }
  }

  public onFileSelected(File: any): void {
    const file: File = File;
    if (file) {
      let fileType = file.type;
      // Solo forzar fileType por extensión si el tipo es 'application/unknown'
      if (fileType === 'application/unknown' && file.name) {
        if (file.name.toLowerCase().endsWith('.pdf')) {
          fileType = 'application/pdf';
        }
      }

      if (fileType === 'application/pdf') {
        const reader = new FileReader();
        reader.onload = () => {
          const base64 = reader.result as string;
          const base64Content = base64.split(',')[1];
          if (this.isValidBase64(base64Content)) {
            this.pdfSrc = base64;
          } else {
            this.generalService.viewSnacAlert(
              'El archivo PDF no es válido.',
              'error',
              'Error al cargar PDF',
            );
            this.pdfSrc = null;
          }
        };
        reader.readAsDataURL(file);
      }

      this.imagePreview = null;
      if (fileType.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = () => {
          this.imagePreview = reader.result;
        };
        reader.readAsDataURL(file);
      }

      if (!(fileType === 'application/pdf') && !fileType.startsWith('image/')) {
        this.isDoc = true;
      }
    }
  }

  public downloadFileFromBlob(): void {
    const url = URL.createObjectURL(this.data.file);
    const link = document.createElement('a');
    link.href = url;
    link.download = this.data.file.name || 'downloaded_file';
    link.click();
    URL.revokeObjectURL(url);
  }
}
